// extracted by mini-css-extract-plugin
export var actionButton = "_kj-0";
export var fileInput = "_kj-2";
export var paperclip = "_kj-1";